import { useState, useEffect } from 'react';

export interface AnonymousUser {
  id: string;
  sessionId: string;
  createdAt: string;
}

export const useAnonymousUser = () => {
  const [anonymousUser, setAnonymousUser] = useState<AnonymousUser | null>(null);

  useEffect(() => {
    // Get or create anonymous user
    let storedUser = localStorage.getItem('anonymousUser');
    
    if (storedUser) {
      setAnonymousUser(JSON.parse(storedUser));
    } else {
      // Create new anonymous user using crypto.randomUUID()
      const newUser: AnonymousUser = {
        id: crypto.randomUUID(),
        sessionId: crypto.randomUUID(),
        createdAt: new Date().toISOString(),
      };
      
      localStorage.setItem('anonymousUser', JSON.stringify(newUser));
      setAnonymousUser(newUser);
    }
  }, []);

  const refreshSession = () => {
    if (anonymousUser) {
      const updatedUser = {
        ...anonymousUser,
        sessionId: crypto.randomUUID(),
      };
      localStorage.setItem('anonymousUser', JSON.stringify(updatedUser));
      setAnonymousUser(updatedUser);
    }
  };

  return {
    anonymousUser,
    refreshSession,
  };
};